import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { mathVariableMap, browserNavMap, userInteractionMap, logicMap, verifyMap, dataMap, alertsMap, draopDownMap, utilityMap,apiMap, gettingStartedMap } from './xpeer-guides-map';

@Component({
  selector: 'ze-user-guide',
  templateUrl: './user-guide.component.html',
  styleUrls: ['./user-guide.component.scss']
})
export class UserGuideComponent implements OnInit {

  @ViewChild('sidebar', { static: false }) sidebarRef!: ElementRef;
  @ViewChild('sidebarToggle', { static: false }) sidebarToggleRef!: ElementRef;

  sidebar: HTMLElement;
  sidebarToggle: HTMLElement;
  sidebarSlide: HTMLElement;
  mainContent: HTMLElement;

  initInstallationClick(): void {
    // Use event delegation on the sidebar to catch clicks
    this.sidebar.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;
      const menuItem = target.closest('.menu-item[data-content="installation"]');
      
      if (menuItem) {
        console.log('Installation clicked!');
        e.preventDefault();
        e.stopPropagation();
        
        this.setActiveMenuItem(menuItem as HTMLElement);
        const content = this.getGettingStartedMap()['installation'];
        console.log('Installation content:', content ? 'Found' : 'Not found');
        this.mainContent.innerHTML = content;
      }
    });

    // Also handle keyboard events
    this.sidebar.addEventListener('keydown', (e) => {
      const target = e.target as HTMLElement;
      const menuItem = target.closest('.menu-item[data-content="installation"]');
      
      if (menuItem && (e.key === 'Enter' || e.key === ' ')) {
        console.log('Installation keyboard activated!');
        e.preventDefault();
        e.stopPropagation();
        
        this.setActiveMenuItem(menuItem as HTMLElement);
        const content = this.getGettingStartedMap()['installation'];
        console.log('Installation content:', content ? 'Found' : 'Not found');
        this.mainContent.innerHTML = content;
      }
    });
  }

  initBestPracticesClick(): void {
    // Use event delegation on the sidebar to catch clicks
    this.sidebar.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;
      const menuItem = target.closest('.menu-item[data-content="best-practices"]');
      
      if (menuItem) {
        console.log('Best Practices clicked!');
        e.preventDefault();
        e.stopPropagation();
        
        this.setActiveMenuItem(menuItem as HTMLElement);
        const content = this.getGettingStartedMap()['best-practices'];
        console.log('Best Practices content:', content ? 'Found' : 'Not found');
        this.mainContent.innerHTML = content;
      }
    });

    // Also handle keyboard events
    this.sidebar.addEventListener('keydown', (e) => {
      const target = e.target as HTMLElement;
      const menuItem = target.closest('.menu-item[data-content="best-practices"]');
      
      if (menuItem && (e.key === 'Enter' || e.key === ' ')) {
        console.log('Best Practices keyboard activated!');
        e.preventDefault();
        e.stopPropagation();
        
        this.setActiveMenuItem(menuItem as HTMLElement);
        const content = this.getGettingStartedMap()['best-practices'];
        console.log('Best Practices content:', content ? 'Found' : 'Not found');
        this.mainContent.innerHTML = content;
      }
    });
  }

  loadInitialContent(): void {
    // Load the content for the initially active tab (What is XPeer.AI?)
    const content = this.getGettingStartedMap()['what-is'];
    if (content && this.mainContent) {
      this.mainContent.innerHTML = content;
    }
  }

  ngOnInit(): void {
    this.sidebar = document.getElementById('sidebar')!;
    this.sidebarToggle = document.getElementById('sidebar-toggle')!;
    this.sidebarSlide = document.getElementById('sidebar-slide')!;
    this.mainContent = document.getElementById('main-content')!;

    this.initSidebarToggle();
    this.initSlideLogic();
    this.initExpandableMenus(); // <-- Add this line
    this.initSearch();

    this.initGettingStartedClick(); // <-- Add this line
    this.initWhatIsClick(); // <-- Add this line
    this.initInstallationClick(); // <-- Add this line
    this.initBestPracticesClick(); // <-- Add this line
    
    // Load initial content for the active tab
    this.loadInitialContent();

  }

  ngAfterViewInit(): void {
    this.sidebar = this.sidebarRef.nativeElement;
    this.sidebarToggle = this.sidebarToggleRef.nativeElement;
    this.sidebarSlide = document.getElementById('sidebar-slide')!;
    this.mainContent = document.getElementById('main-content')!;

    this.initSidebarToggle();
    this.initSlideLogic();
    this.initExpandableMenus(); // <-- Add this line
    this.initSearch();

    this.initGettingStartedClick(); // <-- Add this line
    this.initWhatIsClick(); // <-- Add this line
    this.initInstallationClick(); // <-- Add this line
    this.initBestPracticesClick(); // <-- Add this line

  }


  getbrowserNavMap(): { [key: string]: string } {
    return browserNavMap;
  }
  getUserInteractionMap(): { [key: string]: string } {
    return userInteractionMap
  }
  getMathVariableMap(): { [key: string]: string } {
    return mathVariableMap;
  }
  getLogicMap(): { [key: string]: string } {
    return logicMap;
  }
  getVerifyMap(): { [key: string]: string } {
    return verifyMap;
  }
  getDataMap(): { [key: string]: string } {
    return dataMap;
  }
  getAlertsMap(): { [key: string]: string } {
    return alertsMap;
  }
  getDropDownMap(): { [key: string]: string } {
    return draopDownMap;
  }
  getUtilityMap(): { [key: string]: string } {
    return utilityMap;
  }
  getApiMap(): { [key: string]: string } {
    return apiMap;
  }
  getGettingStartedMap(): { [key: string]: string } {
    return gettingStartedMap;
  }



  initSidebarToggle(): void {
    this.sidebarToggle.addEventListener('click', () => {
      this.setSidebarState(this.sidebar.classList.contains('collapsed'));
    });

    this.sidebarToggle.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.sidebarToggle.click();
      }
    });
  }

  setSidebarState(open: boolean): void {
    if (open) {
      this.sidebar.classList.remove('collapsed');
      this.sidebarToggle.setAttribute('aria-expanded', 'true');
    } else {
      this.sidebar.classList.add('collapsed');
      this.sidebarToggle.setAttribute('aria-expanded', 'false');
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    if (window.innerWidth > 900) {
      this.setSidebarState(true);
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(e: MouseEvent): void {
    if (window.innerWidth <= 900 &&
      !this.sidebar.contains(e.target as Node) &&
      e.target !== this.sidebarToggle) {
      this.setSidebarState(false);
    }
  }

  initSlideLogic(): void {
    // Browser
    this.addSlideLogic(
      '#guides #browser-nav-parent',
      'sidebar-child-panel',
      'browser-nav-child-menu',
      'sidebar-child-back',
      this.getbrowserNavMap(),
      'child'
    );
    // Interaction
    this.addSlideLogic(
      '#guides .menu-item[data-content="user-interaction"]',
      'interaction-child-panel',
      'interaction-child-menu',
      'interaction-child-back',
      this.getUserInteractionMap(),
      'child-interaction'
    );
    // Math & Vars
    this.addSlideLogic(
      '#guides .menu-item[data-content="math-variable"]',
      'math-vars-child-panel',
      'math-vars-child-menu',
      'math-vars-child-back',
      this.getMathVariableMap(),
      'child-math-vars'
    );
    // Logic
    this.addSlideLogic(
      '#guides .menu-item[data-content="logic-flow"]',
      'logic-child-panel',
      'logic-child-menu',
      'logic-child-back',
      this.getLogicMap(),
      'child-logic'
    );
    // Verify
    this.addSlideLogic(
      '#guides .menu-item[data-content="assertion-verification"]',
      'verify-child-panel',
      'verify-child-menu',
      'verify-child-back',
      this.getVerifyMap(),
      'child-verify'
    );
    // Get Data
    this.addSlideLogic(
      '#guides .menu-item[data-content="element-retrieval"]',
      'getdata-child-panel',
      'getdata-child-menu',
      'getdata-child-back',
      this.getDataMap(),
      'child-getdata'
    );
    // Alerts
    this.addSlideLogic(
      '#guides .menu-item[data-content="alert-popup"]',
      'alerts-child-panel',
      'alerts-child-menu',
      'alerts-child-back',
      this.getAlertsMap(),
      'child-alerts'
    );
    // Dropdown
    this.addSlideLogic(
      '#guides .menu-item[data-content="dropdown-selection"]',
      'dropdown-child-panel',
      'dropdown-child-menu',
      'dropdown-child-back',
      this.getDropDownMap(),
      'child-dropdown'
    );
    // Utility
    this.addSlideLogic(
      '#guides .menu-item[data-content="utility-actions"]',
      'utility-child-panel',
      'utility-child-menu',
      'utility-child-back',
      this.getUtilityMap(),
      'child-utility'
    );
    // API
    this.addSlideLogic(
      '#guides .menu-item[data-content="api-actions"]',
      'api-child-panel',
      'api-child-menu',
      'api-child-back',
      this.getApiMap(),
      'child-api'
    );
  }

  addSlideLogic(
    parentSelector: string,
    panelId: string,
    menuId: string,
    backId: string,
    detailsMap: { [key: string]: string },
    slideClass: string
  ): void {
    const parent = document.querySelector(parentSelector);
    const panel = document.getElementById(panelId);
    const back = document.getElementById(backId);

    if (!parent || !panel || !back) return;

    parent.classList.add('has-child');

    parent.addEventListener('click', (e) => {
      this.sidebarSlide.classList.add(slideClass);
      panel.classList.add('open');
      e.stopPropagation();
    });

    back.addEventListener('click', (e) => {
      this.sidebarSlide.classList.remove(slideClass);
      panel.classList.remove('open');
      e.stopPropagation();
    });

    document.querySelectorAll(`#${menuId} .menu-item`).forEach(item => {
      item.addEventListener('click', (e) => {
        const key = item.getAttribute('data-content')!;
        this.setActiveMenuItem(item as HTMLElement);
        this.mainContent.innerHTML = detailsMap[key] || `<h1>${item.textContent}</h1>`;
        e.stopPropagation();
      });

      item.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          item.dispatchEvent(new Event('click'));
        }
      });
    });
  }

  setActiveMenuItem(item: HTMLElement): void {
    document.querySelectorAll('.menu-item').forEach(i => i.classList.remove('active'));
    item.classList.add('active');

    document.querySelectorAll('.menu-item').forEach(i => i.removeAttribute('aria-current'));
    item.setAttribute('aria-current', 'page');
  }

  blueNoteBox(text: string): string {
    return `<div class='blue-note'><span class='icon'>&#9432;</span><strong>Note:</strong> <span>${text}</span></div>`;
  }

  initExpandableMenus(): void {
    const expandableItems = this.sidebar.querySelectorAll('.menu-item.expandable');
    expandableItems.forEach(item => {
      item.addEventListener('click', (e) => {
        if (e.target !== item && !(e.target as HTMLElement).classList.contains('expand-toggle')) return;
        const submenu = item.querySelector('.submenu');
        const arrow = item.querySelector('.expand-toggle');
        const expanded = item.getAttribute('aria-expanded') === 'true';
        if (submenu) {
          submenu.classList.toggle('open', !expanded);
        }
        if (arrow) {
          arrow.classList.toggle('open', !expanded);
        }
        item.setAttribute('aria-expanded', (!expanded).toString());
        e.stopPropagation();
      });
      item.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          item.dispatchEvent(new Event('click'));
        }
      });
    });
  }


  initSearch(): void {
    const input = document.getElementById('guide-search') as HTMLInputElement | null;
    const clearBtn = document.getElementById('guide-search-clear') as HTMLButtonElement | null;
    const results = document.getElementById('guide-search-results') as HTMLElement | null;
    if (!input || !results) return;

    // Collect things we may hide during search (section headings and menus)
    const headings = Array.from(this.sidebar.querySelectorAll('h2')) as HTMLElement[];
    const menus = Array.from(this.sidebar.querySelectorAll('.menu, .submenu')) as HTMLElement[];

    const items = Array.from(this.sidebar.querySelectorAll('.menu-item')) as HTMLElement[];
    type IndexItem = { text: string; el: HTMLElement; category: string };
    const index: IndexItem[] = items.map(el => {
      let category = '';

      // If item is inside a submenu, try to find a parent expandable title
      const submenu = el.closest('.submenu');
      if (submenu) {
        const parentExpandable = submenu.closest('.menu-item.expandable');
        if (parentExpandable) {
          if (parentExpandable.firstChild) {
            const fcText = (parentExpandable.firstChild as Element).textContent;
            category = fcText ? fcText.trim() : (parentExpandable.textContent || '').trim();
          } else {
            category = (parentExpandable.textContent || '').trim();
          }
        }
      } else {
        // Otherwise, find the nearest preceding h2
        const parentMenu = el.closest('.menu');
        if (parentMenu) {
          const prev = parentMenu.previousElementSibling;
          if (prev && prev.tagName.toLowerCase() === 'h2') category = (prev.textContent || '').trim();
        }
      }

      return { text: (el.textContent || '').trim().toLowerCase(), el: el, category };
    });

    let activeIndex = -1;
    const clearResults = (restoreMenus = true) => {
      results.innerHTML = '';
      results.setAttribute('hidden', 'true');
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
      input.setAttribute('aria-expanded', 'false');
      if (clearBtn) clearBtn.setAttribute('hidden', 'true');
      if (restoreMenus) {
        headings.forEach(h => (h.style.display = ''));
        menus.forEach(m => (m.style.display = ''));
      }
    };

    const showResultsFor = (matches: IndexItem[]) => {
      results.innerHTML = '';
      if (!matches.length) {
        const empty = document.createElement('div');
        empty.className = 'search-empty';
        empty.textContent = 'No results found';
        results.appendChild(empty);
        return;
      }

      matches.forEach((m, idx) => {
        const el = document.createElement('div');
        el.className = 'search-result';
        el.setAttribute('role', 'option');
        el.tabIndex = 0;
        el.id = `search-result-${idx}`;

        const title = document.createElement('div');
        title.className = 'search-result-title';
        title.textContent = m.el.textContent ? m.el.textContent.trim() : '';
        el.appendChild(title);

        if (m.category) {
          const cat = document.createElement('div');
          cat.className = 'search-result-cat';
          cat.textContent = m.category;
          el.appendChild(cat);
        }

        // Pressed visual feedback for click
        el.addEventListener('mousedown', () => el.classList.add('pressed'));
        el.addEventListener('mouseup', () => el.classList.remove('pressed'));
        el.addEventListener('mouseleave', () => el.classList.remove('pressed'));

        el.addEventListener('click', (e) => {
          // add a short-lived clicked state for better feel
          el.classList.add('clicked');
          setTimeout(() => el.classList.remove('clicked'), 1100);

          // trigger the original menu item click to reuse handlers
          m.el.click();

          // clear search and restore view
          input.value = '';
          clearResults();
          input.focus();
          e.stopPropagation();
        });

        el.addEventListener('keydown', (e: KeyboardEvent) => {
          if (e.key === 'Enter') el.click();
        });

        results.appendChild(el);
      });
    };

    input.addEventListener('input', () => {
      const q = (input.value || '').trim().toLowerCase();
      results.innerHTML = '';
      if (!q) {
        clearResults(true);
        return;
      }

      // Hide the normal menus/headings
      headings.forEach(h => (h.style.display = 'none'));
      menus.forEach(m => (m.style.display = 'none'));

      if (clearBtn) clearBtn.removeAttribute('hidden');

      const matches = index.filter(i => i.text.includes(q)).slice(0, 200);
      showResultsFor(matches);
      results.removeAttribute('hidden');
      input.setAttribute('aria-expanded', 'true');
      activeIndex = -1;
    });

    const updateActive = () => {
      const list = Array.from(results.querySelectorAll('.search-result')) as HTMLElement[];
      list.forEach((li, idx) => li.classList.toggle('active', idx === activeIndex));
      if (activeIndex >= 0 && list[activeIndex]) {
        (list[activeIndex] as HTMLElement).scrollIntoView({ block: 'nearest' });
        input.setAttribute('aria-activedescendant', `search-result-${activeIndex}`);
      }
    };

    input.addEventListener('keydown', (e: KeyboardEvent) => {
      const list = Array.from(results.querySelectorAll('.search-result')) as HTMLElement[];
      if (results.hasAttribute('hidden')) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIndex = Math.min(activeIndex + 1, list.length - 1);
        updateActive();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = Math.max(activeIndex - 1, 0);
        updateActive();
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (activeIndex >= 0 && list[activeIndex]) (list[activeIndex] as HTMLElement).click();
      } else if (e.key === 'Escape') {
        input.value = '';
        clearResults(true);
        input.blur();
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        input.value = '';
        clearResults(true);
        input.focus();
      });
    }

    // If clicking outside while search is active and input is empty we'll restore menus
    document.addEventListener('click', (e) => {
      if (!results.contains(e.target as Node) && e.target !== input && e.target !== clearBtn) {
        if (!input.value) clearResults(true);
      }
    });
  }


  initGettingStartedClick(): void {
    const gettingStartedItem = document.querySelector('.menu-item[data-content="getting-started"]');
    if (gettingStartedItem) {
      gettingStartedItem.addEventListener('click', (e) => {
        const key = gettingStartedItem.getAttribute('data-content')!;
        this.setActiveMenuItem(gettingStartedItem as HTMLElement);
        this.mainContent.innerHTML = this.getGettingStartedMap()[key] || `<h1>${gettingStartedItem.textContent}</h1>`;
        e.stopPropagation();
      });

      gettingStartedItem.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          gettingStartedItem.dispatchEvent(new Event('click'));
        }
      });
    }
  }

  initWhatIsClick(): void {
    // Use event delegation on the sidebar to catch clicks
    this.sidebar.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;
      const menuItem = target.closest('.menu-item[data-content="what-is"]');
      
      if (menuItem) {
        console.log('What is XPeer.AI clicked!');
        e.preventDefault();
        e.stopPropagation();
        
        this.setActiveMenuItem(menuItem as HTMLElement);
        const content = this.getGettingStartedMap()['what-is'];
        console.log('What is XPeer.AI content:', content ? 'Found' : 'Not found');
        this.mainContent.innerHTML = content;
      }
    });

    // Also handle keyboard events
    this.sidebar.addEventListener('keydown', (e) => {
      const target = e.target as HTMLElement;
      const menuItem = target.closest('.menu-item[data-content="what-is"]');
      
      if (menuItem && (e.key === 'Enter' || e.key === ' ')) {
        console.log('What is XPeer.AI keyboard activated!');
        e.preventDefault();
        e.stopPropagation();
        
        this.setActiveMenuItem(menuItem as HTMLElement);
        const content = this.getGettingStartedMap()['what-is'];
        console.log('What is XPeer.AI content:', content ? 'Found' : 'Not found');
        this.mainContent.innerHTML = content;
      }
    });
  }

}
